var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { getObservableT } from "../Infra/i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { ContactMethod } from "healthex-common/consentconfig.dtos";
const t = getObservableT("patients");
export class HeaderViewModelMobile {
    constructor(container) {
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.dashboardUIManager = container.patientResearchDashboardUIManager;
    }
    get hasUnifiedRecordExpired() {
        return this.dashboardUIManager.hasUnifiedRecordExpired;
    }
    get unifiedRecordSummary() {
        return this.dashboardUIManager.unifiedRecordSummary;
    }
    get isUnifiedRecordDownloadable() {
        return this.dashboardUIManager.isUnifiedRecordDownloadable;
    }
    get isUnifiedRecordProcessing() {
        return this.dashboardUIManager.isUnifiedRecordProcessing;
    }
    get noConsentsAvailable() {
        return this.dashboardUIManager.noConsentsAvailable;
    }
    get showSharingNoRequestsIcon() {
        var _a;
        if (this.noConsentsAvailable === NOT_LOADED)
            return false;
        return ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_SHARING.routeName && this.noConsentsAvailable;
    }
    get mobilePageTitle() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                if (this.noConsentsAvailable === NOT_LOADED)
                    return t("Sharing");
                if (this.noConsentsAvailable)
                    return t("No share requests yet");
                return t("Sharing");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return t("Details");
            case NamedRoutes.PATIENT_MY_HEALTHEX.routeName: {
                if (this.authManager.firstName) {
                    return t("Hi, {{ firstName }}!", { firstName: this.authManager.firstName });
                }
                else {
                    return t("Hi!");
                }
            }
            default:
                return null;
        }
    }
    get mobilePageText() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                if (this.noConsentsAvailable === NOT_LOADED)
                    return t("Manage who can access your health records");
                if (this.noConsentsAvailable)
                    return t("When someone requests access to your health records, you’ll see it here. You can review each request on your terms.");
                return t("Manage who can access your health records");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return null;
            case NamedRoutes.PATIENT_MY_HEALTHEX.routeName: {
                if (this.isUnifiedRecordDownloadable && this.hasUnifiedRecordExpired !== true) {
                    return this.getTextForPreferredContactMethod(t("We’ve emailed your copy of your records to {{ email }}.", {
                        email: this.authManager.email,
                    }), t("We’ve sent your copy of your records to {{ phone }}.", {
                        phone: this.authManager.formattedPhone,
                    }));
                }
                else if (this.isUnifiedRecordProcessing === true) {
                    const commonText = t("We’re still working on your HealthEx Unified Record.");
                    return this.getTextForPreferredContactMethod(`${commonText} ${t("Once we’re done, we'll email a copy to {{ email }}.", {
                        email: this.authManager.email,
                    })}`, `${commonText} ${t("Once we’re done, we'll send it to {{ phone }}.", {
                        phone: this.authManager.formattedPhone,
                    })}`);
                }
                else {
                    return t("See your health history, all in one secure document.");
                }
            }
            default:
                return null;
        }
    }
    getTextForPreferredContactMethod(defaultPreferredContactMethodText, phoneText) {
        if (this.dashboardUIManager.preferredContactMethod === NOT_LOADED)
            return defaultPreferredContactMethodText;
        if (this.dashboardUIManager.preferredContactMethod === ContactMethod.TEXT) {
            return phoneText;
        }
        else {
            return defaultPreferredContactMethodText;
        }
    }
    get headerGap() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 16;
            case NamedRoutes.PATIENT_SHARING.routeName:
            case NamedRoutes.PATIENT_MY_HEALTHEX.routeName:
                return 40;
            default:
                return 0;
        }
    }
    get headerPaddingBottom() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return 12;
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 0;
            case NamedRoutes.PATIENT_MY_HEALTHEX.routeName:
                return 24;
            default:
                return 0;
        }
    }
    get mobileOnBack() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return () => this.routingUIManager.navigateTo(NamedRoutes.PATIENT_SHARING);
            default:
                return null;
        }
    }
    get showSimplifiedHeader() {
        var _a;
        return ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_SHARING_DETAILS.routeName;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "hasUnifiedRecordExpired", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "unifiedRecordSummary", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "isUnifiedRecordDownloadable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "isUnifiedRecordProcessing", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "noConsentsAvailable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "showSharingNoRequestsIcon", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "mobilePageTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "mobilePageText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "headerGap", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "headerPaddingBottom", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "mobileOnBack", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelMobile.prototype, "showSimplifiedHeader", null);
